import React from "react";
import { hourHeight } from "../../calendar";
import "./HoursIndicate.css";
const HoursIndicate = ({ calculatedWidth }) => {
  const halfHours = Array.from({ length: 48 }, (_, i) => i / 2);
  return (
    <>
      {halfHours.map((hour, index) => (
        <div
          role="hour-line"
          key={hour}
          className="hours-indicator"
          style={{
            top: `${hour * hourHeight}px`,
            height: `${hourHeight / 2}px`,
            width: calculatedWidth,
          }}
        >
          <div className="hour-label ng_p_1_sb">
            {`${Math.floor(hour).toString().padStart(2, "0")}:${
              index % 2 === 0 ? "00" : "30"
            }`}
          </div>
          <div className={`hour-line ${index % 2 === 0 && "dotted-border"}`} />
          <div className="hour-left-line" />
        </div>
      ))}
    </>
  );
};

export default HoursIndicate;
